import { SectionsKey } from '~/constants/enum';

const PageStruct = {
    id: 'about-us',
    useLayout: true,
    children: [{ id: SectionsKey.CMSPage, order: 1, dataKey: SectionsKey.CMSPage }]
};

export default PageStruct;
